import cx from "classnames"
import { type ReactNode, useEffect, useRef, useState } from "react"

export const GridDisclosure = ({ open, renderContent }: { open: boolean; renderContent: () => ReactNode }) => {
    const [mounted, setMounted] = useState(open)
    const containerRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        if (open) setMounted(true)
        if (containerRef.current) containerRef.current.inert = !open
    }, [open])

    return (
        <div
            ref={containerRef}
            className={cx(
                "grid transition-[grid-template-rows,opacity] duration-200 ease-out",
                open ? "grid-rows-[1fr] opacity-100" : "pointer-events-none grid-rows-[0fr] opacity-0"
            )}
            aria-hidden={!open}
            onTransitionEnd={(event) => {
                if (event.target === event.currentTarget && !open) setMounted(false)
            }}
        >
            <div className="min-h-0 overflow-hidden">{open || mounted ? renderContent() : null}</div>
        </div>
    )
}
